import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import RefundCodeForm from 'Services/ControlDataManagement/Features/RefundCode/Components/RefundCodeForm'
import { useCreateSingleRefundCodeMutation } from 'Services/ControlDataManagement/Features/RefundCode/refundCodeApi'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { CONTROL_DATA_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { t } from 'ttag'

export default function RefundCodeCreatePage() {
  const baseUrl = `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/refund-codes`
  const previousLocation = usePreviousLocation(baseUrl)

  const [, { isLoading: submitLoading }] = useCreateSingleRefundCodeMutation()

  const breadcrumbs = [
    {
      title: t`Home`,
      link: CONTROL_DATA_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Refund codes`,
      link: baseUrl
    },
    {
      title: t`Create new refund code`
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Create new refund code`}</PageTitle>
        </Grid>
      </Grid>
      <RefundCodeForm successBaseUrl={previousLocation} submitLoading={submitLoading} />
    </Box>
  )
}
